import { isAxiosError } from "axios";
import { HTTP_STATUS } from "utils/httpStatus";

const expectedErrors = [HTTP_STATUS.UNAUTHORIZED, HTTP_STATUS.NOT_FOUND];
export const isExpectedError = (error: unknown) =>
  isAxiosError(error) && error.response?.status && expectedErrors.includes(error.response?.status);
